import { ApiGetRequest, ApiPostRequest } from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Form Container Back to Stock',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Form Container Back to Stock',
        href: '/opc/back-to-stock',
        active: true,
      },
    ],
    loading: false,
    form: {},
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeBackStock(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchContainer({ commit }, payload = null) {
    commit('changeBackStock', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/container/stock-out`, payload);
    commit('changeBackStock', {
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async submitBackStock({ commit, state, dispatch }) {
    commit('changeBackStock', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/container/back-stock`, data.form);
    commit('changeBackStock', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return !result.error ? true : false;
  },
};
